exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beacon-bias-input input{font-size:2em!important}", ""]);

// exports
